import { Fragment } from 'react';
import { Provider } from 'react-redux';

import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { CarPaint } from './views/CarPaint';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<CarPaint />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.CarPaint)
	.build();

export default Layout;
